import React from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@optimusgps/optimus-intl';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import RangePicker from '../../../OptimusRoutes/components/dayjs/RangePicker';
import { addTimeToDate, getEndOf, getNormalizedDateTime, getStartOf, subtractDate } from '../../../utilities/dateUtils';
import unitSystem from '../../unitSystems';

const RangeDateFormitem = ({ onChange }) => {
	const intl = useIntl();

	const ranges = {
		[`${intl.formatMessage(translate('today'))}`]: [getStartOf('day'), getEndOf('day')],
		[`${intl.formatMessage(translate('lastWeek'))}`]: [
			addTimeToDate(getStartOf('week'), -1, 'week'),
			addTimeToDate(getEndOf('week'), -1, 'week'),
		],
		[`${intl.formatMessage(translate('lastMonth'))}`]: [
			getStartOf('month', subtractDate(1, 'month')),
			getEndOf('month', subtractDate(1, 'month')),
		],
		[`${intl.formatMessage(translate('thisMonth'))}`]: [getStartOf('month'), getEndOf('day')],
	};

	return (
		<Form.Item
			name="dateRange"
			label={intl.formatMessage(translate('dateRange'))}
			initialValue={[
				getNormalizedDateTime('00:00:00', 'HH:mm:ss'),
				getNormalizedDateTime('23:59:59', 'HH:mm:ss'),
			]}
			rules={[
				{
					required: true,
					message: intl.formatMessage(translate('selectRangeDate')),
				},
			]}
		>
			<RangePicker
				ranges={ranges}
				disabledDate={(current) => {
					return current && current > getEndOf('day');
				}}
				showTime={true}
				format={unitSystem.getCompleteDateTimeFormat()}
				onChange={onChange}
			/>
		</Form.Item>
	);
};

RangeDateFormitem.defaultProps = {
	onChange: () => {},
};

RangeDateFormitem.propTypes = {
	onChange: PropTypes.func,
};

export default RangeDateFormitem;
